import { PeopleAltOutlined } from '@material-ui/icons';
import React from 'react';

const UserIcon = ({ color }) => <PeopleAltOutlined style={{ color }} />;

export default UserIcon;
